export default __webpack_public_path__ + "static/media/sticker-S.994c2c5e.png";